export default __webpack_public_path__ + "static/media/book-2.81ee3de9.jpeg";